import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";
import { errorDispatch } from "../../../functions/errorDispatch";
import i18next from "../../../functions/i18next";

export default {
  props: {
    mySpace: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      id: this.$options.name,
      optionsData: {},
      focus: true,
    };
  },
  created() {
    EventBus.$on(`${this.$options.name}-show`, (data) => {
      //show this overlay
      EventBus.$emit("openOverlayPage", data);

      if (data.optionsData) {
        this.optionsData = data.optionsData;
      } else {
        this.optionsData = {};
      }

      this.focusInput();
    });

    EventBus.$on(`${this.$options.name}-rename`, (data) => {
      if (data.id) {
        this.renameItem();
      }
    });
  },

  methods: {
    renameItem() {
      let postFunc = null;
      const formData = new FormData(this.$refs.renameFileForm);

      formData.append("myspace", this.mySpace);

      if (this.optionsData.extension) {
        //is file
        //add to update
        formData.append("filetoupdate", this.optionsData.fileId);

        //post file
        postFunc = this.$axios.post(`${baseUrl}/filerename`, formData);
      } else {
        //is folder
        //add to update
        formData.append("foldertoupdate", this.optionsData.fileId);

        //post folder
        postFunc = this.$axios.post(`${baseUrl}/folderupdate`, formData);
      }

      postFunc
        .then((r) => {
          //update files
          EventBus.$emit("mobile-collection-update", {});
          EventBus.$emit("mobile-files-update", {});

          //close overlay
          EventBus.$emit("closeOverlayPage", { id: this.$options.name });

          //reset the focus
          this.focus = false;
        })
        .catch((e) => {
          if (this.optionsData.extension) {
            errorDispatch(i18next.t("error.rename_file"));
          } else {
            errorDispatch(i18next.t("error.rename_folder"));
          }
        });
    },

    enterFunc(e) {
      e.preventDefault();

      this.renameItem();
    },
    focusInput() {
      this.focus = !this.focus;
    },
  },

  computed: {
    isFile() {
      return this.optionsData.extension;
    },
  },
};
